import { useReduxState } from 'hooks';
import { Badge } from 'components/common';

interface Props {
  categories: string[];
}

const CourseCategories = ({ categories }: Props) => {
  const { messages } = useReduxState();

  return categories.length ? (
    <div aria-label={messages.commonCategories} className="categories">
      <div className="category">
        <Badge size="small" text={categories[0]} />
      </div>
      {categories.length > 1 ? (
        <div className="category">
          <Badge
            size="small"
            text={`+${categories.length - 1} ${messages.courseOthers}`}
            tooltip={categories.slice(1).join(', ')}
          />
        </div>
      ) : null}

      <style jsx>{`
        .category {
          display: inline-block;
          margin-right: 10px;
        }
      `}</style>
    </div>
  ) : null;
};

export default CourseCategories;
